<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-case code="declaration1" v-model="sasMediationFamiliale.attestationVeridicite" :live="liveSasMediationFamiliale(7708)"></opq-case>
    <opq-case code="declaration2" v-model="sasMediationFamiliale.attestationEchange" :live="liveSasMediationFamiliale(7709)"></opq-case>
    <opq-case code="declaration3" v-model="sasMediationFamiliale.engagementFormation" :live="liveSasMediationFamiliale(7710)"></opq-case>
    <opq-file
      code="fichier-assermentation"
      :file="sasMediationFamiliale.attestationDAssermentation"
      :live="liveSasMediationFamiliale(7711)"
    ></opq-file>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasMediationFamiliale() {
      return this.sas.sasMediationFamiliale
    }
  },

  methods: {
    liveSasMediationFamiliale(cle) {
      return { endpoint: "sas-mediation-familiale", cle: cle, fileId: this.sasMediationFamiliale.id }
    }
  }
}
</script>

<style>
</style>